import { Button } from '@peritasai/ui-components';
import React from 'react';

export interface SubmitButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({ children, disabled, onClick }) => (
  <Button
    variant="contained"
    fullWidth
    size="large"
    disabled={disabled}
    onClick={onClick}
    sx={{ borderRadius: '24px', height: 52 }}
  >
    {children}
  </Button>
);
